import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Configuration } from '@azure/msal-browser';
import { b2cPolicyConfigDev, b2cPolicyConfigProd, b2cPolicyDev, b2cPolicyProd } from '@app/shared/configs/auth-config';

@Injectable({ providedIn: "root" })
export class Environment {


    public defaultImagePath: string = "assets/img/misc/noimage.jpg";
    public urlMap = new Map([
        ["http://localhost:4200", "https://localhost:5010/"],
        ["https://localhost:51500", "https://localhost:51500/"],
        ["http://localhost:5002", "http://localhost:21800/"],
        ["http://localhost:5001", "http://localhost:21800/"],


        ["https://dadev07.designautomator.com", "https://backend-dev.designautomator.com/"],
        ["https://datest.designautomator.com", "https://backend-dev.designautomator.com/"],
        ["https://dauat.designautomator.com", "https://backend-uat.designautomator.com/"],
        ["https://portal.designautomator.com", "https://backend-prod.designautomator.com/"],

        ["https://appservice-da-admin-dev-auc8c3ezeyeab7e8.northeurope-01.azurewebsites.net", "https://appservice-da-backend-dev-hfbtefbxgwbzh3h9.northeurope-01.azurewebsites.net/"],
        ["https://appservice-da-admin-uat-hzfpb7c6budyfeez.northeurope-01.azurewebsites.net","https://appservice-da-backend-uat-g7g9f6cfgfdaf8fa.northeurope-01.azurewebsites.net/"],
        ["https://appservice-da-admin-prod-ckcqb9fyhvhzcghu.northeurope-01.azurewebsites.net","https://appservice-da-backend-prod-fabcg9fdfse7akeg.northeurope-01.azurewebsites.net/"]

    ]);

    public static ssoConfigMap = new Map([
        ["http://localhost:4200", b2cPolicyConfigDev],
        ["https://dadev07.designautomator.com", b2cPolicyConfigDev],
        ["https://datest.designautomator.com", b2cPolicyConfigDev],
        ["https://dauat.designautomator.com", b2cPolicyConfigProd],
        ["https://portal.designautomator.com", b2cPolicyConfigProd],

        ["https://appservice-da-admin-dev-auc8c3ezeyeab7e8.northeurope-01.azurewebsites.net", b2cPolicyConfigDev],
        ["https://appservice-da-admin-uat-hzfpb7c6budyfeez.northeurope-01.azurewebsites.net", b2cPolicyConfigProd],
        ["https://appservice-da-admin-prod-ckcqb9fyhvhzcghu.northeurope-01.azurewebsites.net", b2cPolicyConfigProd],

    ]);

    public static ssoPolicyMap = new Map([
        ["http://localhost:4200", b2cPolicyDev],
        ["https://dadev07.designautomator.com", b2cPolicyDev],
        ["https://datest.designautomator.com", b2cPolicyDev],
        ["https://dauat.designautomator.com", b2cPolicyProd],
        ["https://portal.designautomator.com", b2cPolicyProd],

        ["https://appservice-da-admin-dev-auc8c3ezeyeab7e8.northeurope-01.azurewebsites.net", b2cPolicyDev],
        ["https://appservice-da-admin-uat-hzfpb7c6budyfeez.northeurope-01.azurewebsites.net", b2cPolicyProd],
        ["https://appservice-da-admin-prod-ckcqb9fyhvhzcghu.northeurope-01.azurewebsites.net", b2cPolicyProd],

    ]);

    constructor(private router: Router) {

    }
    public getBaseUrl(): string {
        var backendServiceUrl = this.urlMap.get(window.location.origin);
        var baseUrl = backendServiceUrl != null ? backendServiceUrl : environment.rawBaseUrl;
        return baseUrl;
    }
    public isDevelopment(): boolean {
        return window.location.origin.includes("localhost");
    }
    public static getSsoMsalConfig(): Configuration {
        var msalConfiguration = Environment.ssoConfigMap.get(window.location.origin);
        return msalConfiguration != null ? msalConfiguration : b2cPolicyConfigDev;
    }

    public static getSsoPolicy() {
        var ssoPolicy = Environment.ssoPolicyMap.get(window.location.origin);
        return ssoPolicy != null ? ssoPolicy : b2cPolicyDev;
    }

}
